import React, { Component } from 'react'
import DOMPurify from 'dompurify';

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import RegexVerification from './regex_verification'
import RadioButton from '../common/radioButton'
import RadioGroup from '../common/radioGroup'
import queryString from 'query-string'

export default class Registration2mid extends Component {
  constructor(props) {
    super(props)
    this.focusText = React.createRef()
    this.props.updateActivePage(2)

    this.state = {
      input: { 
        validationCode: { value: '', type: 'text' },
        isDependant: { value: '', type: 'radio' },
      },
      validateOn: '',
      verificationPageTitle: '',
      verificationPageInstructions: '',
      useLeadingZeros: '',
      submitClick: false
    }
    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }

    this.verificationError = this._verificationError.bind(this)
    this.updateFromHistory = this._updateFromHistory.bind(this)
    this.next = this._next.bind(this)
    this.back = this._back.bind(this)
  }

  handleChange(name, valueOrEvent) {
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        this.handleStateChange(name, curInputValue)
        break
      case 'radio':
        this.handleStateChange(name, valueOrEvent)
        break
      default: break
    }
  }

  handleStateChange(name, value) {
    this.setState({ 
      input: { ...this.state.input,
        [name]: {...this.state.input[name], 
          value: value 
        }
      }
    }, () => {
      this.props.replaceHistoryState(this.state, this.props.history)
    })
  }

  _next(e) {
    e.preventDefault()
    this.setState({ submitClick: true })
    const { validateOn } = this.state
    for (let property in this.state.input) {
      if (property !== 'isDependant' || validateOn === 'SID-JPMC') {
        if (!this.isValid(property)) {
          this.focusElements[property].focus()
          return
        }
      }
    }
    return this.props.next(this.props.match.path, this.state)
  }

  _back(e) {
    return this.props.back(this.props.match.path, this.state)
  }

  isEmpty(name) {
    if (this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    if (this.state.input[name] === undefined) return true
    switch (this.state.input[name].type) {
      case 'radio':
        return document.getElementById("isDependant_true_radio").checked || document.getElementById("isDependant_false_radio").checked
      case 'text':
          return RegexVerification[this.state.validateOn].test(this.state.input[name].value)
      default:
    }
  }

  _verificationError() {
    let errorText = ""
    const { validateOn } = this.state
    if (this.props.verError) {
      if (this.props.verErrorMessage === '') {
        if (validateOn === "SID" || validateOn === "SID-JPMC") {
          errorText = "Please ensure the SID entered is correct or call Client Care at 1-888-639-8181. If you are using Internet Explorer(IE11), please try again in Chrome or Firefox."
        } else if (validateOn === "GENERIC") {
          errorText = "Please ensure the entered value is correct or call Client Care at 1-888-639-8181."
        }
        else {
          errorText = "The information entered does not match our records. Please ensure your data is correct or call Client Care at 1-888-639-8181."
        }      
      } else {
        if (this.props.verErrorMessage === "JPMC not eligible A") {
          return (
            <div aria-live="polite" className="error">You are not currently eligible for this program, please go to Virgin Pulse to view your Additional Wellness Activities.</div>
          )
        }
        else if (this.props.verErrorMessage === "JPMC not eligible X") {
          return (
            <div aria-live="polite" className="error">You must complete a Wellness Screening to participate in Additional Wellness Activities. Please go to My Health (<a class="error-link" href="https://myhealth.jpmorganchase.com" target="_blank" rel="noopener noreferrer">myhealth.jpmorganchase.com</a> or type go/myhealth into your intranet browser) for information on how to get your screening.</div>
          )
        }
        else if (this.props.verErrorMessage === "Not eligible") {
          return (
            <div aria-live="polite" className="error">Based on your employer’s eligibility criteria, you cannot register for the Newtopia program. Please contact your HR group to find out what other programs are being offered that may be a better fit for you.</div>
          )
        }
        else if (this.props.verErrorMessage === "Participant Next Step URL not found") {
          return (
            <div aria-live="polite" className="error">An error occurred during the registration process. Please contact the Client Care team.</div>
          )
        }
      }
    }
    return (
      <div aria-live="polite" className="error">{errorText}</div>
    )
  }

  displayErrors(name, errorId) {
    if (this.state.submitClick) {
      if (!this.isValid(name)) {
        switch (this.state.input[name].type) {
          case 'radio':
            return (
              <div id={errorId} tabIndex="-1" className="error">This field is required.</div>
            )
          case 'text':
            if (this.isEmpty(name)) {
              return (
                <div id={errorId} tabIndex="-1" className="error">This field is required.</div>
              )
            }
            return (
              <div id={errorId} tabIndex="-1" className="error">Invalid input.</div>
            )
          default:
        }
      }
    } 
    return (
      <div id={errorId} tabIndex="-1" className="error"></div>
    )
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  displaySecurityForm() {
    const { validateOn, verificationPageTitle, verificationPageInstructions} = this.state
    let purifiedHTML = DOMPurify.sanitize(verificationPageInstructions);
    let isDependantInitial = ""
    if (validateOn === "MEMBER ID") {
      return (
        <div className="form-input">
          <div id="registration_p2_mid_text">
            <label for="registration_p2_mid">
              <div className="form-heading">
                INSURANCE MEMBER ID
              </div>
              <div>
                If you are a family member (a dependent) of the primary policy holder, 
                please use the 2 digit number located in front of your name as the suffix with a hyphen before it.
                <span> <b>Employee ID number example: W123456789 | Dependent ID number example: W123456789-02</b></span>
              </div>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_mid"
            type="text"
            placeholder="Enter ID number here"
            aria-labelledby="registration_p2_mid_text"
            aria-describedby="registration_p2_mid_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_mid" 
          />
          {this.displayErrors("validationCode", "registration_p2_mid_error")}
          <div>
            <img className="full-width-img" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/d01b64cc-027f-4366-ade3-3b11f4471d3b.png" alt="aetna member ID card"/>
          </div>
        </div>
      );
    } else if (validateOn === "SID") {
      return (
        <div className="form-input">
          <div id="registration_p2_sid_text">
            <label for="registration_p2_sid"> 
              <div className="form-heading">
                Standard ID Number
              </div>
              <div>
                Please enter your SID Number.
              </div>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_sid"
            type="text"
            placeholder="Enter SID here"
            aria-labelledby="registration_p2_sid_text"
            aria-describedby="registration_p2_sid_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_sid" 
          />
          {this.displayErrors("validationCode", "registration_p2_sid_error")}
        </div>
      );
    } else if (validateOn === "UNIQUE ID") {
      return (
        <div className="form-input">
          <div id="registration_p2_uid_text">
            <label for="registration_p2_uid"> 
              <div className="form-heading">
                Employee ID Number
              </div>
              <div>
                Please enter your Employee ID Number. 
                If you are a family member (a dependent) of the primary policy holder (the employee), please ask them to share their Employee ID Number.
              </div>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_uid"
            type="text"
            placeholder="Enter digits here"
            aria-labelledby="registration_p2_uid_text"
            aria-describedby="registration_p2_uid_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_uid" 
          />
          {this.displayErrors("validationCode", "registration_p2_uid_error")}
        </div>
      );
    } else if (validateOn === "SSN") {
      return (
        <div className="form-input">
          <div id="registration_p2_ssn_text">
            <label for="registration_p2_ssn"> 
              <div className="form-heading">
                Last 4 digits of your SSN 
              </div>
              <div>
                Please enter the last 4 digits of your Social Security Number.
              </div>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_ssn"
            type="text"
            placeholder="Enter digits here"
            aria-labelledby="registration_p2_ssn_text"
            aria-describedby="registration_p2_ssn_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_ssn" 
          />
          {this.displayErrors("validationCode", "registration_p2_ssn_error")}
        </div>
      );
    } else if (validateOn === "SID-JPMC") {
      return (
        <div className="form-input">
          <div id="registration_p2_sid_text">
            <label for="registration_p2_sid"> 
          <div className="form-input">
              <h3 id="registration_p2_sid_jpmc_text">Member Verification</h3>
              <RadioGroup
                name="isDependant"
                initial={isDependantInitial}
                ariaLabelledby="registration_p2_sid_jpmc_text"
                radioRef={this.makeRef.bind(this, "isDependant")}
                ariaDescribedby="registration_p2_sid_jpmc_error"
                onChange={this.handleChange.bind(this, "isDependant")}
                dataAtId="reg_p2_sid_jpmc"
              >
                <RadioButton value="false" label="I am a JPMC employee" />
                <RadioButton value="true" label={<span>I am a spouse/domestic partner of a JPMC employee <strong>(for Simplified Wellness Program ONLY)</strong></span>}/>
              </RadioGroup>
              {this.displayErrors("isDependant", "registration_p2_sid_jpmc_error")}
            </div>
            <br/>
            <div>
              Please enter <strong>your</strong> JPMC SID Number or <strong>the JPMC employee's SID number</strong> if you are covered as a spouse/domestic partner under the JPMC medical plan.
            </div>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_sid"
            type="text"
            placeholder="Enter SID here"
            aria-labelledby="registration_p2_sid_text"
            aria-describedby="registration_p2_sid_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_sid_jpmc_text" 
          />
          {this.displayErrors("validationCode", "registration_p2_sid_error")}
        </div>
      );
    } else if (validateOn === "GENERIC") {
      return (
        <div className="form-input">
          <div id="registration_p2_generic_text">
            <label for="registration_p2_generic"> 
              <div className="form-heading">
                {verificationPageTitle}
              </div>
              <div dangerouslySetInnerHTML={{ __html: purifiedHTML}}/>
            </label>
          </div>
          <input
            ref={this.makeRef.bind(this, "validationCode")}
            value={this.state.input.validationCode.value}
            id="registration_p2_generic"
            type="text"
            placeholder="Enter here"
            aria-labelledby="registration_p2_generic_text"
            aria-describedby="registration_p2_generic_error"
            onChange={this.handleChange.bind(this, "validationCode")}
            data-atid="reg_p2_generic"
          />
          {this.displayErrors("validationCode", "registration_p2_generic_error")}
        </div>
      );
    }
  } 

  _updateFromHistory() {
    if (this.props.history.location.state) {
      const historyState = this.props.history.location.state
      let newInputState = {}
      for (let property in this.state.input) {
        if (historyState[property]) {
          newInputState[property] = historyState[property]
        }
      }
      this.setState({ 
        input: { ...this.state.input,
          ...newInputState,
        }
      })
    }
  }

  async componentDidMount() {
    let regCode = queryString.parse(window.location.search).regCode
    if (regCode) {
      await this.props.getClientData()
      this.props.updateActivePage(2)
    }
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    window.scrollTo(0, 0)
    const historyState = this.props.history.location.state
    if (historyState && historyState.Validate_On) {
        this.setState({ ...this.state,
          validateOn: historyState.Validate_On,
          verificationPageTitle: historyState.Verification_Page_Title__c,
          verificationPageInstructions: historyState.Verification_Page_Instructions__c,
          useLeadingZeros: historyState.Use_Leading_Zeros__c,
        })
    }
    this.updateFromHistory()
  }

  render() {
    const verificationDisplay = this.displaySecurityForm()

    return (
      <div id="registration_2">
        <AriaMessage message="Navigated to registration page 2" />
        <Title>Verification</Title>
        <div className="container form-container">
          {verificationDisplay}
          {this.verificationError()}
          <Privacy />
          <Controls 
            back={this.back} 
            next={this.next} 
            dataAtId="reg_p2" 
          />
        </div>
      </div>
    )
  }
}